import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSaveComment } from "src/api/client-api/property/useSaveComment";
import { useDeleteComment } from "src/api/client-api/property/useDeleteComment";
import { format, parseISO } from "date-fns";
import { CommentDialogHeader } from "./CommentDialogHeader";
import { CommentDialogActions } from "./CommentDialogActions";
import { CommentDialogContent } from "./CommentDialogContent";
import { ConfirmDeleteDialog } from "./ConfirmDeleteDialog";
import { invalidateEntitiesPosts } from "src/api/client-api/post/useGetOnePost";
import { useQueryClient } from "react-query";
import { usePropertyContext } from "../context/usePropertyContext";
import { BottomSheetDialog } from "@foodpilot/foods";

export type CommentData = {
    comment: string;
    commentId: string;
    updatedAt: string;
    userName: string;
};

export const CommentDialog = () => {
    const { t } = useTranslation();
    const { commentState, changePost, post } = usePropertyContext();
    const { comment, commentId, updatedAt, userName } = commentState.commentDialogData?.commentData ?? {};
    const canAnswerSsq = post.canAnswerSsq;

    const updatedAtFormatted = updatedAt ? format(parseISO(updatedAt), "dd/MM/yyyy, HH:mm") : null;

    const [newComment, setNewComment] = useState(comment ?? "");
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

    const queryClient = useQueryClient();
    const saveComment = useSaveComment();
    const deleteComment = useDeleteComment();

    useEffect(() => {
        const c = comment ?? "";
        setNewComment(c);
    }, [comment]);

    const handleCancel = () => {
        setNewComment(comment ?? "");
        commentState.closeDialog();
    };

    const handleSave = () => {
        const elementId = commentState.commentDialogData?.ssqPostElementId;
        if (elementId === undefined) return;

        saveComment.mutate(
            { comment: newComment, ssqPostElementId: elementId },
            {
                onSuccess: () => {
                    changePost();
                    // commentState.setComment({ ssqPostElementId: elementId, commentData: newComment });
                    commentState.closeDialog();
                    invalidateEntitiesPosts(queryClient);
                },
            },
        );
    };

    const handleDeleteAndSave = () => {
        if (!commentId) return;
        deleteComment.mutate(commentId, {
            onSuccess: () => handleSave(),
        });
    };

    const handleDelete = () => {
        if (!commentId) return;
        deleteComment.mutate(commentId, {
            onSuccess: () => {
                changePost();
                commentState.deleteComment();
                commentState.closeDialog();
                invalidateEntitiesPosts(queryClient);
            },
        });
    };
    return (
        <>
            <BottomSheetDialog
                open={commentState.isCommentDialogOpen}
                setOpen={commentState.setOpenCommentDialog}
                title={
                    (
                        <CommentDialogHeader
                            title={t("property.attachment.edit_note", "Edit a note")}
                            onClose={() => commentState.closeDialog()}
                        />
                    ) as any
                }
                content={
                    (
                        <>
                            <CommentDialogContent
                                newComment={newComment}
                                onChange={setNewComment}
                                isReadOnly={!canAnswerSsq}
                                placeholder={t("property.note.placeholder")}
                                updatedAtFormatted={
                                    updatedAtFormatted ?
                                        `${t("property.note.last_edited")} ${updatedAtFormatted}`
                                    :   null
                                }
                                userName={userName}
                            />

                            <CommentDialogActions
                                commentId={commentId}
                                comment={comment}
                                newComment={newComment}
                                canAnswerSsq={canAnswerSsq}
                                onCancel={handleCancel}
                                onDeleteClick={() => setConfirmDeleteOpen(true)}
                                onSave={handleSave}
                                onDeleteAndSave={handleDeleteAndSave}
                            />
                        </>
                    ) as any
                }
            />
            <ConfirmDeleteDialog
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
                onConfirm={() => {
                    handleDelete();
                    setConfirmDeleteOpen(false);
                }}
            />

            {/* <Dialog
                open={commentState.isCommentDialogOpen}
                onClose={() => handleCancel()}
                maxWidth="md"
                fullWidth
                sx={{ borderRadius: theme.spacing(40) }}
            >
                <CommentDialogHeader
                    title={t("property.attachment.edit_note", "Edit a note")}
                    onClose={() => commentState.closeDialog()}
                />

                <CommentDialogContent
                    newComment={newComment}
                    onChange={setNewComment}
                    placeholder={t("property.note.placeholder")}
                    updatedAtFormatted={
                        updatedAtFormatted ? `${t("property.note.last_edited")} ${updatedAtFormatted}` : null
                    }
                    userName={userName}
                />

                <CommentDialogActions
                    commentId={commentId}
                    comment={comment}
                    newComment={newComment}
                    onCancel={handleCancel}
                    onDeleteClick={() => setConfirmDeleteOpen(true)}
                    onSave={handleSave}
                    onDeleteAndSave={handleDeleteAndSave}
                />
            </Dialog>

            <ConfirmDeleteDialog
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
                onConfirm={() => {
                    handleDelete();
                    setConfirmDeleteOpen(false);
                }}
            /> */}
        </>
    );
};
